export const translations = {
  EN: {
    app_name: 'Routemind',
    dashboard: 'Dashboard',
    offers: 'Offers',
    my_offers: 'My Offers',
    analytics: 'Analytics',
    settings: 'Settings',
    logout: 'Logout',
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    full_name: 'Full Name',
    organization_name: 'Organization Name',
    create_account: 'Create Account',
    already_have_account: 'Already have an account?',
    dont_have_account: "Don't have an account?",
    sign_up: 'Sign Up',
    welcome_back: 'Welcome back',
    sign_in_to_continue: 'Sign in to continue',
    forgot_password: 'Forgot password?',

    // Dashboard KPIs
    total_offers: 'Total Offers',
    won_jobs: 'Won Jobs',
    win_rate: 'Win Rate',
    total_revenue: 'Total Revenue',
    total_profit: 'Total Profit',
    avg_profit: 'Avg Profit per Job',

    // Offer list
    create_offer: 'Create Offer',
    offer_no: 'Offer No',
    customer: 'Customer',
    mode: 'Mode',
    lane: 'Lane',
    carrier: 'Carrier',
    currency: 'Currency',
    total_sale: 'Total Sale',
    total_cost: 'Total Cost',
    profit: 'Profit',
    margin: 'Margin',
    status: 'Status',
    validity: 'Valid Until',
    created: 'Created',
    actions: 'Actions',
    created_by: 'Created By',
    search_offer_number: 'Search offer number...',
    all_customers: 'All Customers',
    all_status: 'All Status',
    all_mode: 'All Mode',
    showing: 'Showing',
    of: 'of',
    clear_all_filters: 'Clear all filters',
    no_offers_found: 'No offers found',

    // Status
    draft: 'Draft',
    sent: 'Sent',
    won: 'Won',
    won_via_counter: 'Won via Counter',
    lost: 'Lost',
    passive: 'Passive',

    // Mode
    fcl: 'FCL',
    lcl: 'LCL',
    air: 'Air',

    // Date filter
    today: 'Today',
    this_week: 'This Week',
    this_month: 'This Month',
    all: 'All',

    // Offer Create
    shipment_details: 'Shipment Details',
    customer_name: 'Customer Name',
    search_or_create_customer: 'Search or create customer...',
    customer_ref: 'Customer Reference (Optional)',
    origin: 'Origin',
    destination: 'Destination',
    port_of_loading: 'Port of Loading (POL)',
    port_of_discharge: 'Port of Discharge (POD)',
    carrier_name: 'Carrier Name',
    transit_time: 'Transit Time (Days)',
    validity_date: 'Validity Date',
    offer_language: 'Offer Language',
    carrier_options: 'Carrier Options',
    airline_quotes: 'Airline Quotes',
    buy_rate: 'Buy Rate',
    sell_rate: 'Sell Rate',
    add_airline: '+ Add Airline',
    add_charge: '+ Charge',

    // Freight
    freight_pricing: 'Freight Pricing',
    freight_cost: 'Freight Cost',
    freight_sale: 'Freight Sale Price',
    unit_price: 'Unit Price',
    quantity: 'Quantity',
    total: 'Total',
    rate_basis: 'Rate Basis',
    chargeable_weight: 'Chargeable Weight (CW)',
    cost_per_unit: 'Cost per Unit',
    sale_per_unit: 'Sale per Unit',
    incoterm: 'Incoterm',

    // Cargo
    cargo_dimensions: 'Cargo Dimensions',
    length: 'Length',
    width: 'Width',
    height: 'Height',
    actual_weight: 'Actual Weight',
    volumetric_weight: 'Volumetric Weight',
    minimum_weight: 'Minimum Weight',
    dangerous_goods: 'Dangerous Goods',
    transit_days: 'Transit (days)',
    free_time_days: 'Free Time (days)',

    // Local charges
    local_charges: 'Local Charges',
    local_cost: 'Local Cost',
    local_sale: 'Local Sale Price',

    // Pre-carriage
    pre_carriage: 'Pre-carriage',
    pre_carriage_included: 'Pre-carriage included?',
    pre_carriage_supplier: 'Supplier',
    pre_carriage_cost: 'Pre-carriage Cost',
    pre_carriage_sale: 'Pre-carriage Sale',
    pre_carriage_profit: 'Pre-carriage Profit',
    pre_carriage_notes: 'Notes (optional)',

    // Pricing summary
    pricing_summary: 'Pricing Summary',
    sale: 'Sale',
    cost: 'Cost',
    freight_profit: 'Freight Profit',
    local_profit: 'Local Profit',

    // Actions
    save_draft: 'Save Draft',
    send_offer: 'Send Offer',
    update_offer: 'Update Offer',
    cancel: 'Cancel',
    send_email: 'Send Email',
    email_to: 'To',
    email_cc: 'CC (optional)',
    email_subject: 'Subject',
    email_body: 'Message',
    send: 'Send',
    view: 'View',
    edit: 'Edit',
    create_revision: 'Create Revision',
    mark_won: 'Mark Won',
    mark_lost: 'Mark Lost',
    chain_locked_terminal: 'This offer is locked — counter chain is in terminal state (WON or LOST)',
    chain_locked_not_latest: 'This offer is locked — only the latest counter offer in the chain can be modified',
    chain_locked_original: 'This original offer has a counter — please use the latest counter offer instead',
    download_pdf: 'Download PDF',
    duplicate: 'Duplicate',

    // Export
    export: 'Export',
    export_to_csv: 'Export to CSV',

    // Dashboard
    vs_last_period: 'vs last period',
    margin_healthy: 'margin healthy',
    quotes_expiring_today: 'quotes expiring today',
    quotes_expiring_soon: 'quotes expiring soon',
    quotes_awaiting_followup: 'quotes awaiting follow-up',
    customers_at_risk: 'customers at risk',
    team_members_inactive: 'team members inactive',
    route_margin_dropped: 'route margin dropped below 15%',
    revenue_vs_cost: 'Revenue vs Cost',
    last_12_months: 'Last 12 months',
    gap_profit_margin: 'Gap = profit margin',
    quote_pipeline: 'Quote Pipeline',
    no_offers_yet: 'No offers yet',
    create_first_offer: 'Create your first offer',
    new_offer_cta: 'New Offer',
    no_revenue_data_yet: 'No data yet — won offers will appear here',
    follow_up_pending: 'Follow-up Pending',
    pending_follow_up_count: 'offers pending follow-up',
    potential_revenue: 'potential revenue',
    potential_profit: 'potential profit',
    view_all: 'View all',
    days_waiting: 'days waiting',
    day_waiting: 'day waiting',
    sales_user_column: 'Sales User',
    route_column: 'Route',
    wait_time_column: 'Wait Time',
    revenue_column: 'Revenue',
    profit_column: 'Profit',
    offer_no_column: 'Offer No',
    customer_column: 'Customer',
    view_details_arrow: 'View →',
    go_button: 'go',
    team_performance: 'Team performance',
    conversion: 'Conversion',
    follow_up_queue: 'Follow-up queue',
    action_needed: 'Action needed',
    d_ago: 'd ago',
    view_details: 'View details',
    manager: 'Manager',
    all_time: 'All Time',
    custom_range: 'Custom Range',
    no_sales_data: 'No sales data available',
    no_pending_followups: 'No pending follow-ups',
    needs_coaching: 'needs coaching',
    on_offers: 'on offers',
    monthly_offer_target: 'Monthly offer target',
    remaining: 'remaining',
    no_target_set: 'No target set',
    won_this_month: 'won this month',
    follow_up_rate: 'Follow-up rate',
    of_sent_quotes: 'of sent quotes',
    not_tracked_yet: 'Not tracked yet',
    good_morning: 'Good morning',
    good_afternoon: 'Good afternoon',
    good_evening: 'Good evening',
    no_contact: 'No contact',
    at_risk: 'At risk',
    cooling: 'Cooling',
    strong: 'Strong',
    upcoming: 'Upcoming',
    revenue: 'Revenue',
    dashboard_deals_count: 'deals',

    // Analytics
    loss_analysis: 'Loss Analysis',
    route_carrier_intelligence: 'Route × Carrier Intelligence',
    salesperson_performance: 'Salesperson Performance',
    win_rate_trend: 'Win Rate Trend',
    customer_risk_analysis: 'Customer Risk Analysis',
    counter_offer_analysis: 'Counter Offer & Discount Analysis',
    customer_profitability: 'Customer Profitability',
    customer_route_combos: 'Customer × Route Combinations',
    most_profitable: 'Most Profitable',
    needs_attention: 'Needs Attention',
    lane_performance: 'Lane Performance',
    carrier_comparison: 'Carrier Comparison',
    monthly_trends: 'Monthly Trends',
    // Analytics — detail strings
    offers_lost_period: 'offers lost this period',
    lost_due_to_price: 'lost due to price',
    potential_profit: 'Potential Profit',
    validity_expiring: 'offers validity expiring within 3 days (sent)',
    pending_followup: 'offers sent 7+ days ago — follow-up needed',
    days_remaining: 'days left',
    days_waiting: 'days waiting',
    more_offers: 'more offers',
    most_profitable_combos: 'Most profitable combinations',
    attention_needed_combos: 'Combinations needing attention',
    combinations: 'combinations',
    route_based: 'Route based',
    carrier_based: 'Carrier based',
    strongest_combo: 'Strongest combination',
    cost_warning: 'Cost warning',
    low_performance: 'Low performance',
    last_3_months: 'last 3 months',
    price_increased: 'price increased',
    review: 'review',
    no_data_for_mode: 'No data for this mode',
    lost_offers: 'lost offers',
    all_customers: 'All Customers',
    all_modes: 'All Modes',
    all_sales: 'All Sales',
    loss_reason_price: 'Price (Higher than competitor)',
    loss_reason_transit: 'Transit Time (Not suitable)',
    loss_reason_competitor: 'Lost to Competitor',
    loss_reason_cancelled: 'Customer Cancelled',
    loss_reason_no_response: 'No Response',
    loss_reason_other: 'Other',
    loss_reason_unknown: 'Unknown (Legacy)',
    loss_short_price: 'Price',
    loss_short_transit: 'Transit',
    loss_short_competitor: 'Competitor',
    loss_short_cancelled: 'Cancelled',
    loss_short_no_response: 'No Response',
    loss_short_other: 'Other',
    loss_short_unknown: 'Unknown',
    // Loss reason modal
    loss_modal_title: 'Loss Reason',
    loss_modal_subtitle: 'This data will be used in future pricing and strategy decisions',
    loss_desc_price: 'Our price was higher than competitor',
    loss_desc_transit: 'Transit time was not suitable',
    loss_desc_competitor: 'Lost to a specific competitor',
    loss_desc_cancelled: 'Customer cancelled the shipment',
    loss_desc_no_response: 'Customer did not respond',
    loss_desc_other: 'Other reason',
    loss_competitor_name: 'Competitor Name',
    loss_please_specify: 'Please specify',
    loss_select_reason: 'Please select a loss reason',
    loss_optional: 'optional',
    loss_details_placeholder: 'Please provide more details...',
    loss_competitor_placeholder: 'Enter competitor name...',
    loss_note_label: 'Detail note (optional)',
    loss_note_placeholder: 'E.g.: Customer said they received a $200 cheaper offer from competitor...',
    loss_note_helper: 'This note will be shown in analytics reports',
    loss_saving: 'Saving...',
    no_profitable_routes: 'No profitable route data',
    no_lost_routes: 'No lost route data',
    total_counter_offers: 'Total counter offers',
    accept_rate: 'Accept rate',
    avg_discount: 'Average discount',
    profit_from_counters: 'Profit from counters',
    per_counter: 'per counter',
    counter_valuable: 'Valuable',
    counter_uncertain: 'Uncertain',
    counter_waste: 'Time waste',
    discount_effectiveness: 'Discount effectiveness analysis',
    no_counter_offers: 'No counter offers found',
    focus_this_combo: 'Focus on this combination — high margin and win rate',
    review_pricing: 'Review pricing strategy for this combination',
    offers_label: 'offers',
    persons: 'persons',
    months_3: '3 months',
    months_6: '6 months',
    months_12: '12 months',
    select_customer_detail: 'Select a customer to view details',
    viewing_for: 'Viewing for',
    perf_summary: 'Performance summary of all operations',
    no_lost_offers: 'No lost offers found for the selected filters',
    customer_search: 'Search customer...',
    stable_badge: 'Stable',
    risk_badge: 'Risk',
    silent_badge: 'Silent',
    wr_improved: 'Win rate improved',
    wr_declined: 'Win rate declined',
    wr_stable: 'Win rate stable',
    pricing_strategy: 'pricing strategy improving',
    focus_price_losses: 'Focus on reducing price losses to reach 50% target',
    top_loss_at: 'most losses at',
    due_to: 'due to',
    // Analytics — remaining detail strings
    price_lost_detail: '{count} lost due to price. At avg winning margin ({margin}%), est. {winnable} winnable → extra: {profit}',
    x_lost_offers: '{count} lost offers',
    best_performance: 'best performance',
    getting_expensive: 'getting expensive',
    most_profitable_route: '{lane} most profitable — ${profit} total profit',
    no_profitable_route_data: 'No profitable route data yet',
    highest_loss_rate: '{lane} highest loss rate — {rate}%',
    no_lost_route_data: 'No lost route data yet',
    loss_source_detail: '{reason}-related {count} lost offers total value ${value}',
    attention_needed_wr: 'needs attention — win rate',
    wr_up_detail: 'Win rate up from {from}% to {to}% ↑ — {reason}',
    wr_down_detail: 'Win rate down from {from}% to {to}% ↓',
    wr_stable_detail: 'Win rate stable — avg {avg}%. {advice}',
    wr_target_advice: 'Focus on reducing price losses to reach 50%',
    risk_wr_dropped: '{name} win rate dropped {pct}% in last 3 months',
    silent_no_offers: '{name} no offers for {days} days — check relationship',
    most_reliable: 'Most reliable: {name} — {wr}% win rate, stable',
    counter_accepts_pct: '{name} accepts {pct}% of counter offers — discount strategy works',
    counter_low_accept: '{name} accepted only {won} of {total} counters — get initial price right',
    discount_most_effective: 'Discounts {range} most effective — {pct}% accept rate',
    stabil: 'stable',
    // Insight cards (PricingSummary)
    customer_with_wr: 'With this customer {wr}% win rate, accepted margin range: {spot}',
    in_last_offers: 'In last {count} offers {wr}% win rate, avg margin {margin}%',
    x_offers: '{count} offers',
    percentile_based: 'Percentile: {pct}% · based on {count} won offers',
    improving: 'Improving',
    declining: 'Declining',
    margin_on_target: 'Margin on target',
    margin_low: 'Margin low — check pricing',
    margin_low_short: 'Margin low',
    acceptable_margin_range: 'Acceptable margin range',
    disclaimer: 'RouteMind presents data to optimize your commercial decisions. Final decision belongs to the user.',

    // Settings
    exchange_rates: 'Exchange Rates',
    modules: 'Modules',
    smtp_settings: 'SMTP Settings',
    user_management: 'User Management',
    sales_targets: 'Sales Targets',
    security: 'Security',
    smtp_host: 'SMTP Host',
    smtp_port: 'SMTP Port',
    smtp_username: 'SMTP Username',
    smtp_password: 'SMTP Password',
    smtp_from_email: 'From Email',
    save_settings: 'Save Settings',
    change_password: 'Change Password',

    // Users
    add_user: 'Add User',
    role: 'Role',
    admin: 'Admin',
    sales: 'Sales',
    super_admin: 'Super Admin',
    platform_admin: 'Platform Admin',
    organizations: 'Organizations',
    all_users: 'All Users',
    platform_stats: 'Platform Statistics',
    total_organizations: 'Total Organizations',
    total_users: 'Total Users',
    active: 'Active',
    inactive: 'Inactive',
    deactivate: 'Deactivate',

    // Decision Engine
    routemind_insights: 'ROUTEMIND INSIGHTS',
    customer_behavior: 'Customer behavior',
    price_analysis: 'Price analysis',
    high_confidence: 'High confidence',
    medium_confidence: 'Medium confidence',
    competitive: 'Your price is within the winning average — competitive',
    borderline: 'Your price is in the upper quartile — be careful',
    risky: 'Your price is above the winning range — high loss risk',
    low_accuracy_warning: 'Low accuracy (%X%) — this data is for reference only',

    // Notifications
    notifications: 'Notifications',
    urgent: 'Urgent',
    active_notif: 'Active',
    snoozed: 'Snoozed',
    snooze: 'Snooze',
    dismiss: 'Dismiss',
    no_notifications: 'No notifications',
    remind_again: 'Remind me again on:',

    // Misc
    filters: 'Filters',
    search: 'Search',
    loading: 'Loading...',
    error_occurred: 'An error occurred',
    offer_sent_success: 'Offer sent successfully',
    offer_created_success: 'Offer created successfully',
    offer_updated_success: 'Offer updated successfully',
    settings_saved: 'Settings saved successfully',
    user_created: 'User created successfully',
    no_data: 'No data available',
    confirm: 'Confirm',
    delete: 'Delete',
    save: 'Save',
    close: 'Close',

    // Multi-line cargo (AIR offers)
    add_cargo_details: 'Add Cargo Details',
    length_cm: 'Length (cm)',
    width_cm: 'Width (cm)',
    height_cm: 'Height (cm)',
    pieces: 'Pieces',
    weight_kg: 'Weight (kg)',
    total_pieces: 'Total Pieces',
    total_weight: 'Total Weight',
    total_chargeable_weight: 'Total Chargeable Weight',
    multiple_cargo_lines: 'Multiple sizes ({count} lines)',

    // Astral-specific business rules
    astral_storage_rule_hint: 'Astral Worldwide rule: If billing weight is 300+, sale value is calculated per kg',

    // Quote gating + AIR local-charge labels
    please_select_incoterm: 'Please select an incoterm first',
    awb_fee: 'AWB Fee',
    thc: 'THC',
    delivery_order: 'D/O',
    transit_fee: 'Transit Fee',
    apron_transfer: 'Apron Transfer',
    pickup: 'Pick Up',
  },

  TR: {
    app_name: 'Routemind',
    dashboard: 'Kontrol Paneli',
    offers: 'Teklifler',
    my_offers: 'Tekliflerim',
    analytics: 'Analitik',
    settings: 'Ayarlar',
    logout: 'Çıkış Yap',
    login: 'Giriş Yap',
    register: 'Kayıt Ol',
    email: 'E-posta',
    password: 'Şifre',
    full_name: 'Ad Soyad',
    organization_name: 'Şirket Adı',
    create_account: 'Hesap Oluştur',
    already_have_account: 'Zaten hesabınız var mı?',
    dont_have_account: 'Hesabınız yok mu?',
    sign_up: 'Kayıt Ol',
    welcome_back: 'Tekrar hoş geldiniz',
    sign_in_to_continue: 'Devam etmek için giriş yapın',
    forgot_password: 'Şifrenizi mi unuttunuz?',

    // Dashboard KPIs
    total_offers: 'Toplam Teklif',
    won_jobs: 'Kazanılan İşler',
    win_rate: 'Kazanma Oranı',
    total_revenue: 'Toplam Ciro',
    total_profit: 'Toplam Kâr',
    avg_profit: 'Ortalama Kâr/İş',

    // Offer list
    create_offer: 'Yeni Teklif',
    offer_no: 'Teklif No',
    customer: 'Müşteri',
    mode: 'Taşıma Türü',
    lane: 'Hat',
    carrier: 'Taşıyıcı',
    currency: 'Para Birimi',
    total_sale: 'Toplam Satış',
    total_cost: 'Toplam Maliyet',
    profit: 'Kâr',
    margin: 'Marj',
    status: 'Durum',
    validity: 'Geçerlilik',
    created: 'Oluşturulma',
    actions: 'İşlemler',
    created_by: 'Oluşturan',
    search_offer_number: 'Teklif numarası ara...',
    all_customers: 'Tüm Müşteriler',
    all_status: 'Tüm Durumlar',
    all_mode: 'Tüm Türler',
    showing: 'Gösterilen',
    of: '/',
    clear_all_filters: 'Tüm filtreleri temizle',
    no_offers_found: 'Teklif bulunamadı',

    // Status
    draft: 'Taslak',
    sent: 'Gönderildi',
    won: 'Kazanıldı',
    won_via_counter: 'Karşı Teklifle Kazanıldı',
    lost: 'Kaybedildi',
    passive: 'Pasif',

    // Mode
    fcl: 'FCL',
    lcl: 'LCL',
    air: 'Hava',

    // Date filter
    today: 'Bugün',
    this_week: 'Bu Hafta',
    this_month: 'Bu Ay',
    all: 'Tümü',

    // Offer Create
    shipment_details: 'Gönderi Detayları',
    customer_name: 'Müşteri Adı',
    search_or_create_customer: 'Müşteri ara veya oluştur...',
    customer_ref: 'Müşteri Referansı (Opsiyonel)',
    origin: 'Nereden',
    destination: 'Nereye',
    port_of_loading: 'Yükleme Limanı (POL)',
    port_of_discharge: 'Boşaltma Limanı (POD)',
    carrier_name: 'Taşıyıcı',
    transit_time: 'Transit Süresi (Gün)',
    validity_date: 'Geçerlilik Tarihi',
    offer_language: 'Teklif Dili',
    carrier_options: 'Taşıyıcı Seçenekleri',
    airline_quotes: 'Havayolu Teklifleri',
    buy_rate: 'Alış Fiyatı',
    sell_rate: 'Satış Fiyatı',
    add_airline: '+ Havayolu Ekle',
    add_charge: '+ Masraf Ekle',

    // Freight
    freight_pricing: 'Navlun Fiyatlandırması',
    freight_cost: 'Navlun Maliyeti',
    freight_sale: 'Navlun Satış Fiyatı',
    unit_price: 'Birim Fiyat',
    quantity: 'Miktar',
    total: 'Toplam',
    rate_basis: 'Fiyat Esası',
    chargeable_weight: 'Ücretli Ağırlık (CW)',
    cost_per_unit: 'Birim Maliyeti',
    sale_per_unit: 'Birim Satış Fiyatı',
    incoterm: 'Teslim Şekli',

    // Cargo
    cargo_dimensions: 'Kargo Boyutları',
    length: 'Uzunluk',
    width: 'Genişlik',
    height: 'Yükseklik',
    actual_weight: 'Gerçek Ağırlık',
    volumetric_weight: 'Hacimsel Ağırlık',
    minimum_weight: 'Minimum Ağırlık',
    dangerous_goods: 'Tehlikeli Madde',
    transit_days: 'Transit (gün)',
    free_time_days: 'Serbest Süre (gün)',

    // Local charges
    local_charges: 'Lokal Masraflar',
    local_cost: 'Lokal Maliyet',
    local_sale: 'Lokal Satış Fiyatı',

    // Pre-carriage
    pre_carriage: 'Ön Taşıma',
    pre_carriage_included: 'Ön taşıma dahil mi?',
    pre_carriage_supplier: 'Tedarikçi',
    pre_carriage_cost: 'Ön Taşıma Maliyeti',
    pre_carriage_sale: 'Ön Taşıma Satış',
    pre_carriage_profit: 'Ön Taşıma Kârı',
    pre_carriage_notes: 'Notlar (opsiyonel)',

    // Pricing summary
    pricing_summary: 'Fiyat Özeti',
    sale: 'Satış',
    cost: 'Maliyet',
    freight_profit: 'Navlun Kârı',
    local_profit: 'Lokal Kâr',

    // Actions
    save_draft: 'Taslak Kaydet',
    send_offer: 'Teklif Gönder',
    update_offer: 'Teklifi Güncelle',
    cancel: 'İptal',
    send_email: 'E-posta Gönder',
    email_to: 'Kime',
    email_cc: 'CC (opsiyonel)',
    email_subject: 'Konu',
    email_body: 'Mesaj',
    send: 'Gönder',
    view: 'Görüntüle',
    edit: 'Düzenle',
    create_revision: 'Revizyon Oluştur',
    mark_won: 'Kazanıldı İşaretle',
    mark_lost: 'Kaybedildi İşaretle',
    chain_locked_terminal: 'Bu teklif kilitli — counter zinciri tamamlandı (kazanıldı veya kaybedildi)',
    chain_locked_not_latest: 'Bu teklif kilitli — sadece zincirdeki son counter offer üzerinde işlem yapılabilir',
    chain_locked_original: 'Bu original teklifin counter offerı mevcut — lütfen son counter offer üzerinden işlem yapın',
    download_pdf: 'PDF İndir',
    duplicate: 'Kopyala',

    // Export
    export: 'Dışa Aktar',
    export_to_csv: 'CSV Olarak Dışa Aktar',

    // Dashboard
    vs_last_period: 'önceki döneme göre',
    margin_healthy: 'marj sağlıklı',
    quotes_expiring_today: 'teklif bugün sona eriyor',
    quotes_expiring_soon: 'teklif yakında sona eriyor',
    quotes_awaiting_followup: 'teklif takip bekliyor',
    customers_at_risk: 'müşteri risk altında',
    team_members_inactive: 'ekip üyesi aktif değil',
    route_margin_dropped: 'rota marjı %15 altına düştü',
    revenue_vs_cost: 'Gelir ve Maliyet',
    last_12_months: 'Son 12 ay',
    gap_profit_margin: 'Fark = kâr marjı',
    quote_pipeline: 'Teklif Hattı',
    no_offers_yet: 'Henüz teklif oluşturulmadı',
    create_first_offer: 'İlk teklifinizi oluşturun',
    new_offer_cta: 'Yeni Teklif',
    no_revenue_data_yet: 'Henüz veri yok — kazanılan teklifler burada görünecek',
    follow_up_pending: 'Takip Bekleyen Teklifler',
    pending_follow_up_count: 'teklif takipte',
    potential_revenue: 'potansiyel ciro',
    potential_profit: 'potansiyel kâr',
    view_all: 'Tümünü gör',
    days_waiting: 'gün bekliyor',
    day_waiting: 'gün bekliyor',
    sales_user_column: 'Satışçı',
    route_column: 'Rota',
    wait_time_column: 'Bekleme',
    revenue_column: 'Ciro',
    profit_column: 'Kâr',
    offer_no_column: 'Teklif No',
    customer_column: 'Müşteri',
    view_details_arrow: 'Görüntüle →',
    go_button: 'git',
    team_performance: 'Ekip Performansı',
    conversion: 'Dönüşüm',
    follow_up_queue: 'Takip Kuyruğu',
    action_needed: 'Aksiyon Gerekli',
    d_ago: 'gün önce',
    view_details: 'Detay gör',
    manager: 'Yönetici',
    all_time: 'Tüm Zamanlar',
    custom_range: 'Özel Aralık',
    no_sales_data: 'Satış verisi yok',
    no_pending_followups: 'Bekleyen takip yok',
    needs_coaching: 'koçluk gerekiyor',
    on_offers: 'teklifte',
    monthly_offer_target: 'Aylık teklif hedefi',
    remaining: 'kaldı',
    no_target_set: 'Hedef belirlenmemiş',
    won_this_month: 'bu ay kazanılan',
    follow_up_rate: 'Takip oranı',
    of_sent_quotes: 'gönderilen tekliflerin',
    not_tracked_yet: 'Henüz takip edilmiyor',
    good_morning: 'Günaydın',
    good_afternoon: 'İyi günler',
    good_evening: 'İyi akşamlar',
    no_contact: 'İletişim yok',
    at_risk: 'Riskli',
    cooling: 'Soğuyor',
    strong: 'Güçlü',
    upcoming: 'Yaklaşan',
    revenue: 'Gelir',
    dashboard_deals_count: 'teklif',

    // Analytics
    loss_analysis: 'Kayıp Analizi',
    route_carrier_intelligence: 'Rota × Taşıyıcı İstihbaratı',
    salesperson_performance: 'Satışçı Performansı',
    win_rate_trend: 'Kazanma Oranı Trendi',
    customer_risk_analysis: 'Müşteri Risk Analizi',
    counter_offer_analysis: 'Karşı Teklif ve İndirim Analizi',
    customer_profitability: 'Müşteri Kârlılığı',
    customer_route_combos: 'Müşteri × Rota Kombinasyonları',
    most_profitable: 'En Kârlı',
    needs_attention: 'Dikkat Gerektiren',
    lane_performance: 'Hat Performansı',
    carrier_comparison: 'Taşıyıcı Karşılaştırması',
    monthly_trends: 'Aylık Trendler',
    // Analytics — detail strings
    offers_lost_period: 'teklif bu dönemde kaybedildi',
    lost_due_to_price: 'tanesi fiyat nedeniyle kaybedildi',
    potential_profit: 'Potansiyel Kâr',
    validity_expiring: 'teklif validity süresi 3 gün içinde doluyor (sent)',
    pending_followup: 'teklif 7+ gündür sent durumunda — follow-up gerekiyor',
    days_remaining: 'gün kaldı',
    days_waiting: 'gündür bekliyor',
    more_offers: 'teklif daha',
    most_profitable_combos: 'En kârlı kombinasyonlar',
    attention_needed_combos: 'Dikkat gerektiren kombinasyonlar',
    combinations: 'kombinasyon',
    route_based: 'Rota bazlı',
    carrier_based: 'Taşıyıcı bazlı',
    strongest_combo: 'En güçlü kombinasyon',
    cost_warning: 'Maliyet uyarısı',
    low_performance: 'Düşük performans',
    last_3_months: 'son 3 ayda',
    price_increased: 'pahalılaştı',
    review: 'gözden geçir',
    no_data_for_mode: 'Bu modülde henüz veri yok',
    lost_offers: 'kayıp teklif',
    all_customers: 'Tüm Müşteriler',
    all_modes: 'Tüm Türler',
    all_sales: 'Tüm Satışçılar',
    loss_reason_price: 'Fiyat (Rakipten yüksek)',
    loss_reason_transit: 'Transit Süresi (Uygun değil)',
    loss_reason_competitor: 'Rakibe kaybedildi',
    loss_reason_cancelled: 'Müşteri iptal etti',
    loss_reason_no_response: 'Cevap yok',
    loss_reason_other: 'Diğer',
    loss_reason_unknown: 'Bilinmiyor',
    loss_short_price: 'Fiyat',
    loss_short_transit: 'Transit',
    loss_short_competitor: 'Rakip',
    loss_short_cancelled: 'İptal',
    loss_short_no_response: 'Cevapsız',
    loss_short_other: 'Diğer',
    loss_short_unknown: 'Bilinmiyor',
    // Loss reason modal
    loss_modal_title: 'Kayıp Nedeni',
    loss_modal_subtitle: 'Bu veri gelecekteki fiyatlandırma ve strateji kararlarında kullanılacak',
    loss_desc_price: 'Fiyatımız rakipten yüksekti',
    loss_desc_transit: 'Transit süresi uygun değildi',
    loss_desc_competitor: 'Belirli bir rakibe kaybedildi',
    loss_desc_cancelled: 'Müşteri gönderimi iptal etti',
    loss_desc_no_response: 'Müşteri yanıt vermedi',
    loss_desc_other: 'Diğer nedenler',
    loss_competitor_name: 'Rakip Adı',
    loss_please_specify: 'Lütfen belirtin',
    loss_select_reason: 'Lütfen bir kayıp nedeni seçin',
    loss_optional: 'opsiyonel',
    loss_details_placeholder: 'Daha fazla detay belirtin...',
    loss_competitor_placeholder: 'Rakip adını girin...',
    loss_note_label: 'Detay notu (opsiyonel)',
    loss_note_placeholder: 'Örn: Müşteri rakipten $200 daha ucuz teklif aldığını söyledi...',
    loss_note_helper: 'Bu not analytics raporlarında gösterilecek',
    loss_saving: 'Kaydediliyor...',
    no_profitable_routes: 'Kârlı rota verisi yok',
    no_lost_routes: 'Kayıp rota verisi yok',
    total_counter_offers: 'Toplam karşı teklif',
    accept_rate: 'Kabul oranı',
    avg_discount: 'Ortalama indirim',
    profit_from_counters: 'Karşı tekliften kâr',
    per_counter: 'karşı teklif başına',
    counter_valuable: 'Değerli',
    counter_uncertain: 'Belirsiz',
    counter_waste: 'Zaman kaybı',
    discount_effectiveness: 'İndirim etkinlik analizi',
    no_counter_offers: 'Karşı teklif bulunamadı',
    focus_this_combo: 'Bu kombinasyona odaklanın — yüksek marj ve win rate',
    review_pricing: 'Bu kombinasyonda fiyat stratejisini gözden geçirin',
    offers_label: 'teklif',
    persons: 'kişi',
    months_3: '3 ay',
    months_6: '6 ay',
    months_12: '12 ay',
    select_customer_detail: 'Müşteri seçerek aylık trend görüntüleyin',
    viewing_for: 'için görüntüleniyor',
    perf_summary: 'Tüm operasyonun performans özeti',
    no_lost_offers: 'Seçili filtreler için kayıp teklif bulunamadı',
    customer_search: 'Müşteri ara...',
    stable_badge: 'Stabil',
    risk_badge: 'Risk',
    silent_badge: 'Sessiz',
    wr_improved: 'Win rate iyileşti',
    wr_declined: 'Win rate düştü',
    wr_stable: 'Win rate stabil',
    pricing_strategy: 'fiyatlama stratejiniz iyileşiyor',
    focus_price_losses: 'Hedef %50 için fiyat kayıplarını azaltmaya odaklanın',
    top_loss_at: 'en çok kayıp',
    due_to: 'nedeniyle',
    // Analytics — remaining detail strings
    price_lost_detail: '{count} tanesi fiyat nedeniyle kaybedildi. Ort. kazanma marjıyla ({margin}%) girilseydi tahmini {winnable} kazanılabilirdi → ek kâr: {profit}',
    x_lost_offers: '{count} kayıp teklif',
    best_performance: 'en iyi performans',
    getting_expensive: 'pahalılaşıyor',
    most_profitable_route: '{lane} en kârlı rota — toplam ${profit} kâr',
    no_profitable_route_data: 'Henüz kârlı rota verisi yok',
    highest_loss_rate: '{lane} en yüksek kayıp oranı — %{rate}',
    no_lost_route_data: 'Henüz kayıp rota verisi yok',
    loss_source_detail: '{reason} kaynaklı {count} kayıp teklifin toplam değeri ${value}',
    attention_needed_wr: 'dikkat gerektiriyor — win rate',
    wr_up_detail: 'Win rate {from}%\'den {to}%\'ye yükseldi ↑ — {reason}',
    wr_down_detail: 'Win rate {from}%\'den {to}%\'ye düştü ↓',
    wr_stable_detail: 'Win rate stabil — ortalama {avg}%. {advice}',
    wr_target_advice: 'Hedef %50 için fiyat kayıplarını azaltmaya odaklanın',
    risk_wr_dropped: '{name} win rate son 3 ayda %{pct} düştü',
    silent_no_offers: '{name}\'den {days} gündür teklif yok — ilişkiyi kontrol edin',
    most_reliable: 'En güvenilir: {name} — %{wr} win rate, stabil',
    counter_accepts_pct: '{name} counter offer\'ların %{pct}\'ini kabul ediyor — indirim stratejisi işe yarıyor',
    counter_low_accept: '{name} {total} counter offer\'dan sadece {won}\'ini kabul etti — ilk fiyatı doğru verin',
    discount_most_effective: 'İndirimler {range} arasında en etkili — %{pct} kabul oranı',
    stabil: 'stabil',
    // Insight cards (PricingSummary)
    customer_with_wr: 'Bu müşteri ile %{wr} win rate, kabul marj aralığı: {spot}',
    in_last_offers: 'Son {count} teklifte %{wr} win rate, ort. marj %{margin}',
    x_offers: '{count} teklif',
    percentile_based: 'Percentile: %{pct} · {count} kazanılan teklife göre',
    improving: 'İyileşiyor',
    declining: 'Düşüyor',
    margin_on_target: 'Margin hedef aralığında',
    margin_low: 'Margin düşük — fiyatlandırmayı kontrol edin',
    margin_low_short: 'Marj düşük',
    acceptable_margin_range: 'Kabul edilebilir margin aralığında',
    disclaimer: 'RouteMind ticari kararlarınızı optimize etmek için verileri sunar. Son karar kullanıcıya aittir.',

    // Settings
    exchange_rates: 'Döviz Kurları',
    modules: 'Modüller',
    smtp_settings: 'SMTP Ayarları',
    user_management: 'Kullanıcı Yönetimi',
    sales_targets: 'Satış Hedefleri',
    security: 'Güvenlik',
    smtp_host: 'SMTP Host',
    smtp_port: 'SMTP Port',
    smtp_username: 'SMTP Kullanıcı Adı',
    smtp_password: 'SMTP Şifre',
    smtp_from_email: 'Gönderen E-posta',
    save_settings: 'Ayarları Kaydet',
    change_password: 'Parola Değiştir',

    // Users
    add_user: 'Kullanıcı Ekle',
    role: 'Rol',
    admin: 'Yönetici',
    sales: 'Satış',
    super_admin: 'Süper Admin',
    platform_admin: 'Platform Yöneticisi',
    organizations: 'Organizasyonlar',
    all_users: 'Tüm Kullanıcılar',
    platform_stats: 'Platform İstatistikleri',
    total_organizations: 'Toplam Organizasyon',
    total_users: 'Toplam Kullanıcı',
    active: 'Aktif',
    inactive: 'Pasif',
    deactivate: 'Devre Dışı Bırak',

    // Decision Engine
    routemind_insights: 'ROUTEMIND İÇGÖRÜLER',
    customer_behavior: 'Müşteri davranışı',
    price_analysis: 'Fiyat analizi',
    high_confidence: 'Yüksek güven',
    medium_confidence: 'Orta güven',
    competitive: 'Fiyatınız kazanılan tekliflerin ortalamasında — rekabetçi',
    borderline: 'Fiyatınız kazanılan tekliflerin üst çeyreğinde — dikkatli olun',
    risky: 'Fiyatınız kazanılan aralığın üstünde — kayıp riski yüksek',
    low_accuracy_warning: 'Düşük doğruluk (%X%) — bu veri referans amaçlıdır',

    // Notifications
    notifications: 'Bildirimler',
    urgent: 'Acil',
    active_notif: 'Aktif',
    snoozed: 'Ertelenmiş',
    snooze: 'Ertele',
    dismiss: 'Kapat',
    no_notifications: 'Bildirim yok',
    remind_again: 'Tekrar hatırlat:',

    // Misc
    filters: 'Filtreler',
    search: 'Ara',
    loading: 'Yükleniyor...',
    error_occurred: 'Bir hata oluştu',
    offer_sent_success: 'Teklif başarıyla gönderildi',
    offer_created_success: 'Teklif başarıyla oluşturuldu',
    offer_updated_success: 'Teklif başarıyla güncellendi',
    settings_saved: 'Ayarlar başarıyla kaydedildi',
    user_created: 'Kullanıcı başarıyla oluşturuldu',
    no_data: 'Veri bulunamadı',
    confirm: 'Onayla',
    delete: 'Sil',
    save: 'Kaydet',
    close: 'Kapat',

    // Multi-line cargo (AIR offers)
    add_cargo_details: 'Yük Detayı Ekle',
    length_cm: 'Uzunluk (cm)',
    width_cm: 'Genişlik (cm)',
    height_cm: 'Yükseklik (cm)',
    pieces: 'Adet',
    weight_kg: 'Ağırlık (kg)',
    total_pieces: 'Toplam Adet',
    total_weight: 'Toplam Ağırlık',
    total_chargeable_weight: 'Toplam Ücretlendirilebilir Ağırlık',
    multiple_cargo_lines: 'Çoklu boyut ({count} satır)',

    // Astral-specific business rules
    astral_storage_rule_hint: 'Astralworldwide için kural: Billing weight 300+ ise satış değeri kg başına olarak hesaplanır',

    // Quote gating + AIR local-charge labels
    please_select_incoterm: 'Lütfen önce incoterm seçin',
    awb_fee: 'AWB Ücreti',
    thc: 'THC',
    delivery_order: 'D/O',
    transit_fee: 'Transit Ücreti',
    apron_transfer: 'Apron Transfer',
    pickup: 'Pick Up',
  }
};
